import { render, staticRenderFns } from "./BackupRestore.vue?vue&type=template&id=77d41cc6&scoped=true&"
import script from "./BackupRestore.vue?vue&type=script&lang=js&"
export * from "./BackupRestore.vue?vue&type=script&lang=js&"
import style0 from "./BackupRestore.vue?vue&type=style&index=0&id=77d41cc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d41cc6",
  null
  
)

export default component.exports